<template>
  <div class="user" v-loading="loading">
    <back />
    <div class="">
      <div class="s_wrapper">
        <el-input class="s_input" v-model="nickName" placeholder="请输入用户名称" suffix-icon="el-icon-search" @change="onSearch" clearable></el-input>
        <el-input class="s_input" v-model="userCode" placeholder="请输入用户编号" suffix-icon="el-icon-search" @change="onSearch" clearable></el-input>
        <el-select class="s_input" v-model="sex" placeholder="请选择用户性别" clearable @change="onSearch">
          <el-option v-for="(item, index) in sexOptions" :key="index" :label="item" :value="index"></el-option>
        </el-select>
      </div>

      <div class="g_table">
        <el-table :data="tableData" style="width: 100%" max-height="540">
          <el-table-column label="序号" show-overflow-tooltip width="80">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
            </template>
          </el-table-column>
          <el-table-column min-width="120" show-overflow-tooltip prop="userCode" label="用户编号"></el-table-column>
          <el-table-column min-width="120" show-overflow-tooltip prop="nickName" label="用户昵称"></el-table-column>
          <el-table-column min-width="120" show-overflow-tooltip prop="sex" label="用户性别">
            <template slot-scope="scope">
              <span>{{ sexOptions[scope.row.sex] }}</span>
            </template>
          </el-table-column>
          <el-table-column min-width="120" show-overflow-tooltip prop="phoneNum" label="电话号码">
            <template slot-scope="scope">
              <span>{{ scope.row.phoneNum || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column min-width="120" show-overflow-tooltip prop="createdTime" label="注册时间"></el-table-column>
        </el-table>
      </div>
    </div>

    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalCount"></el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      nickName: "", //姓名
      userCode: "", //用户编号
      sex: "", //性别
      tableData: [],
      sexOptions: { 0: "女", 1: "男", 2: "未知" },
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.loading = true
      try {
        const {
          result: { list, totalCount },
        } = await this.$axios.get(this.$api.userBellowUser, {
          params: {
            userId: this.$route.query.userId,
            sex: this.sex || null,
            nickName: this.nickName || null,
            userCode: this.userCode || null,
            page: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        this.tableData = list
        this.totalCount = totalCount
      } catch (err) {
        this.$message.error(err.desc)
      } finally {
        this.loading = false
      }
    },
    // 搜索
    onSearch() {
      this.tableData = []
      this.currentPage = 1
      this.getList()
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getList()
    },
  },
}
</script>

<style scoped lang="scss">
.user {
  .disabled_user_account {
    width: 255px;
    color: #c0c4cc;
    padding: 0 15px;
    border-radius: 10px;
    background-color: #f5f7fa;
    box-sizing: border-box;
    cursor: not-allowed;
  }
}
</style>
